import { ColumnsType } from "antd/es/table";
import { dateFormatter } from "project-config/utils/date-formatter";
import { useTranslation } from "react-i18next";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import routerUtil from "@/utils/routerUtil";
import styled from "styled-components";
import { OperationButton } from "@/components/operation-button";

const t = getTranslateNsT("center");

export let refundType = new Map([
  [1, t("pay_method_refund_ali")],
  [2, t("pay_method_refund_wechat")],
  [3, t("pay_method_refund_paypal")],
  [13, t("pay_method_refund_offline_recharge")],
  [50, t("pay_method_present50")],
  [52, t("pay_method_present52")],
]);

let MemberType = [
  t("vip_present_category"),
  t("vip_month_category"),
  t("vip_year_category"),
  t("vip_quarterly_category"),
  "",
  "",
  t("vip_semiannual_category"),
];

let statusTemplate = [
  t("pay_status_default"),
  t("pay_status_ing"),
  t("pay_status_success"),
  t("pay_status_cancel"),
  t("pay_status_fail"),
  t("pay_status_refund"),
  t("pay_status_wait_comfirm"),
  t("pay_status_comfirmed"),
  t("pay_status_present"),
];

export let isInvoice = [
  "",
  t("pay_not_invoice"),
  t("pay_can_invoice"),
  t("pay_is_invoice"),
];

export function useMemberColumns() {
  const { t } = useTranslation("center");

  const columns: ColumnsType<any> = [
    { dataIndex: "payRecordId", title: t("member_header_id") },
    {
      dataIndex: "type",
      title: t("member_header_member_type"),
      render: (row) => MemberType[row],
    },
    { dataIndex: "mount", title: t("member_header_mount") },
    {
      dataIndex: "amount",
      title: t("coupon_header_amount"),
      render: (row) => Number(row).toFixed(3),
    },
    {
      dataIndex: "payMethod",
      title: t("record_header_method"),
      render: (row) => refundType.get(row),
    },
    {
      dataIndex: "status",
      title: t("record_header_status"),
      render: (row, record) => {
        if (row === 6) {
          return (
            <div>
              <span>{`${statusTemplate[row]}: `}</span>
              <span style={{ color: "#FF9933" }}>{record.nonPayment}</span>
            </div>
          );
        }
        return statusTemplate[row];
      },
    },
    {
      dataIndex: "confirmTime",
      title: t("member_header_pay_time"),
      render: (row) => dateFormatter(row),
    },
    {
      dataIndex: "endTime",
      title: t("member_header_end_time"),
      render: (row) => dateFormatter(row),
    },
    {
      dataIndex: "invoice",
      title: t("record_header_invoice"),
      render: (_, row) => {
        return row.invoice === 2 ? (
          <>
            <span style={{ marginRight: "10px" }}>{t("pay_invoicing")}</span>
          </>
        ) : (
          isInvoice[row.invoice]
        );
      },
    },
    {
      dataIndex: "handle",
      title: t("record_header_operate"),
      render: (_, row) => {
        return row.invoice === 2 ? (
          <>
            <OperationButton
              text={isInvoice[row.invoice]}
              onClick={() => routerUtil.navigate?.("/invoice")}
            />
          </>
        ) : null;
      },
    },
  ];

  return { columns };
}

export const InvoicingButton = styled.div`
  display: inline-block;
  min-width: 86px;
  width: max-content;
  height: 30px;
  background: var(--color-main-alpha-08);
  border: 1px solid var(--main-color);
  border-radius: 6px;
  font-size: 14px;
  line-height: 30px;
  color: var(--main-color);
  cursor: pointer;
  text-align: center;
`;
